// Every client call to api/QuoteOfTheDay, in one place.
//
// All of them go through readJson: the API answers a rejected token with 401
// and an *empty body*, so a bare .then(r => r.json()) throws SyntaxError and
// loses the real cause. readJson drops the dead token and returns null, and
// every function here turns any failure into null so a caller can fall back
// rather than handle an exception.
import { readJson } from '../actions/apiResponse';

const authorised = (method, body) => {
  const token = localStorage.token;
  if (!token) {
    return null;
  }

  const init = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Authorization': 'Bearer ' + token,
    },
  };

  if (body !== undefined) {
    init.body = JSON.stringify(body);
  }

  return init;
};

// readJson takes (response, label) - the label is what appears in its console
// warning and in the Error it throws on any other failure, so it must be
// passed. It throws for 403, which is exactly what List answers a non-admin;
// the catch turns that into null so a caller shows a message instead of
// crashing a detached window.
const call = (url, method, body) => {
  const init = authorised(method, body);
  if (!init) {
    return Promise.resolve(null);
  }

  return fetch(url, init)
    .then(response => readJson(response, url))
    .catch(() => null);
};

export const fetchToday = () => call('api/QuoteOfTheDay/Today', 'GET');

export const fetchAll = () => call('api/QuoteOfTheDay/List', 'GET');

export const createQuote = (quote) => call('api/QuoteOfTheDay/Create', 'POST', quote);

export const updateQuote = (quote) => call('api/QuoteOfTheDay/Update', 'POST', quote);

export const deleteQuote = (id) => call('api/QuoteOfTheDay/Delete', 'POST', { id: id });

export default { fetchToday, fetchAll, createQuote, updateQuote, deleteQuote };



// WEBPACK FOOTER //
// ./src/utils/quoteOfTheDay.js